import React, { useState, useEffect, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { QRCodeSVG } from "qrcode.react";
import Printdoc from "../../src/components/PDF/PrintDoc";
import moment from "moment";
import {
  pdfLogo,
  registered,
  photoId,
} from "../assests";
import PatientDetails from "../components/Editorderpage/PatientDetails";
import PatientOrderDetails from "../components/Editorderpage/PatientOrderDetails";
import DeliveryInstructions from "../components/Editorderpage/DeliveryInstructions";
import ActionButtons from "../components/Editorderpage/ActionButtons";
import TabButtons from "../components/Editorderpage/TabButtons";
import SlipPreview from "../components/Editorderpage/SlipPreview";
import DateTimeFilters from "../components/Editorderpage/DateTimeFilters";
import {
  getApiWithAuth,
  postApiWithAuth,
  putApiWithAuth,
  patchApiWithAuth,
} from "../utils/api";
import { CREATE_ORDER } from "../utils/apiUrl";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useReactToPrint } from "react-to-print";


const EditPage = ({ isEditable }) => {
  const [activeTab, setActiveTab] = useState(
    isEditable ? "uploaded" : "signed"
  );
  const { oid, route } = useParams();
  const location = useLocation();
  const [loading, setLoading] = useState("");
  const [orderResponse, setOrderResponse] = useState({});
  const [orderDetail, setOrderDetail] = useState({
    id: "",
    createdAt: "",
    deliverAt: new Date(new Date().getTime() + 24 * 60 * 60 * 1000),
    deliverydate: "Anytime",
    name: "",
    streetViewUrl: "",
    language: "english",
    address: "",
    apart: "",
    contact: "",
    cell: "",
    workNumber: "",
    zip: "",
    notes: "",
    slug: "",
    totalcopay: 0,
    signature: false,
    photoid: false,
    refrigrated: false,
    collectcopay: false,
    hippaform: false,
    lineform: false,
    nfaqbform: false,
    addresstype: false,
    parcelPlace: "Face to face",
    lat: "",
    lng: "",
    city_code: '',
    business_start_time: "09:00",
    business_end_time: "17:00",
    deliverAt: "",
    requestCouncelling: false,
    status: "",
    driver: "",
    signature_img: "",
    active: true,
    delivery_imgs: [],
    orderticket: {},
    pharmacyId: "",
    order_file: "",
    parcel_recieved_by_image: "",
    parcel_recieved_by_images: "",
    orderdetail: [
      {
        quantity: '',
        rf_number: '',
        date: '',
        pat_pay_amount: "0.00",
        rx_number: 'M - ',
        select: false,
      },
    ],
  });
  const [pharmacyDetail, setPharmacyDetail] = useState({});
  const [selectedOrderFile, setSelectedOrderFile] = useState(null);
  const [addressError, setAddressError] = useState(null);
  const [showData, setShowData] = useState(false);

  useEffect(() => {
    setShowData(false);

    const timer = setTimeout(() => {
      setShowData(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    getDetailOrder(oid);
  }, [oid]);

  const getDetailOrder = async (id) => {
    const response = await getApiWithAuth(CREATE_ORDER + `/${id}`);
    if (response.data !== undefined) {
      setOrderDetail({
        id: response.data.data?.id,
        name: response.data.data?.name || "",
        address: response.data.data?.address || "",
        contact: response.data.data?.contact || "",
        cell: response.data.data?.cell || "",
        workNumber: response.data.data?.workNumber || "",
        zip: response.data.data?.zip || "",
        slug: response.data.data?.slug || "",
        streetViewUrl: response.data.data?.location_image || "",
        deliverydate: response.data.data?.deliverydate,
        parcelPlace: response.data.data?.parcelPlace,
        signature: response.data.data?.signature,
        photoid: response.data.data?.photoid,
        refrigrated: response.data.data?.refrigrated,
        collectcopay: response.data.data?.collectcopay,
        hippaform: response.data.data?.hippaform,
        lineform: response.data.data?.lineform,
        nfaqbform: response.data.data?.nfaqbform,
        addresstype: response.data.data?.addresstype,
        business_start_time: response.data.data?.business_start_time,
        business_end_time: response.data.data?.business_end_time,
        deliverAt: response.data.data?.deliverAt,
        createdAt: response.data.data?.createdAt,
        totalcopay: response.data.data?.totalcopay,
        language: response.data.data?.language,
        apart: response.data.data?.apart,
        notes: response.data.data?.notes,
        lat: response.data.data?.latitude,
        lng: response.data.data?.longitude,
        lng: response.data.data?.longitude,
        status: response.data.data?.status,
        requestCouncelling: response.data.data?.requestCouncelling,
        ordermaster_route4me: response.data.data?.ordermaster_route4me,
        signature_img:
          response.data.data?.ordermaster_route4me !== null
            ? response.data.data?.ordermaster_route4me[
              response.data.data?.ordermaster_route4me?.length - 1
            ]?.signature_image
            : undefined,
        parcel_recieved_by_image:
          response.data.data?.ordermaster_route4me?.find(
            (item) => item.parcel_recieved_by_image
          )?.parcel_recieved_by_image,
        parcel_recieved_by_images:
          response.data.data?.route_pharmacy_details?.find(
            (item) => item.parcel_recieved_by_image
          )?.parcel_recieved_by_image,
        ordermaster_delivery: response.data.data?.ordermaster_delivery,
        orderticket:
          response.data.data?.orderticket !== null
            ? response.data.data?.orderticket[
            response.data.data?.orderticket?.length - 1
            ]
            : undefined,
        pharmacyId: response.data.data?.pharmacy?.id,
        order_file: response.data.data?.order_file,
        driver: response.data.data?.driver?.name,
        deliverAt: response.data.data?.deliverAt,
        active: response.data.data?.isActive,
        daily_order_id: response.data.data?.daily_order_id,
        orderdetail: response.data.data?.orderdetail || [],
      });
      setPharmacyDetail(response.data.data.pharmacy);
    } else {
      console.log("Error");
    }
  };

  const pid = localStorage.getItem("pharmacyId");
  const navigation = useNavigate();
  const componentRef = useRef(null);

  const reportTemplateRef = useRef(null);

  const handlePrint = useReactToPrint({
    content: () => {
      if (!componentRef.current) {
        return null;
      }
      return componentRef.current;
    },
    onBeforeGetContent: () => {
      console.log("Before getting content...");
    },
    onAfterPrint: () => {
      console.log("Printing complete.");
      navigation("/order-list");
      localStorage.removeItem("orderData");
    },
  });
  const componentRef2 = useRef();

  const downloadUploadSlip = () => {
    window.open(`${orderDetail?.order_file}`, "_blank");
  };

  const handlePrintSlip = useReactToPrint({
    content: () => componentRef2.current,
  });

  const handleOrderChange = (event, index) => {
    const { name, value, type, checked } = event.target;

    let updatedValue = value;

    if (type === "checkbox") {
      updatedValue = checked;
    }

    if (name.includes(".")) {
      const [list, rxIndex, fieldName] = name.split(".");
      const updatedRxList = [...orderDetail.orderdetail];
      updatedRxList[index][fieldName] = updatedValue;

      let totalcopay = 0;

      orderDetail.orderdetail.forEach((rx) => {
        if (rx.select) {
          totalcopay += parseFloat(rx.copay);
        }
      });

      setOrderDetail({
        ...orderDetail,
        orderdetail: updatedRxList,
        totalcopay: totalcopay,
      });
    } else if (name === 'collectcopay') {

      const updatedRxList = orderDetail.orderdetail.map((rx) => ({
        ...rx,
        select: checked,
      }));

      let totalcopay = 0;

      if (checked) {
        orderDetail.orderdetail.forEach((rx) => {
          totalcopay += parseFloat(rx.copay);
        });
      }

      setOrderDetail({
        ...orderDetail,
        [name]: updatedValue,
        orderdetail: updatedRxList,
        totalcopay: totalcopay,
      });
    } else if (name === "zip") {
      const trimmedValue = value.replace(/\s/g, '');

      if (trimmedValue.length <= 5) {
        setOrderDetail(prevState => ({
          ...prevState,
          [name]: trimmedValue
        }));
      }
    } else {
      // It's a top-level field in orderDetail
      setOrderDetail({
        ...orderDetail,
        [name]: updatedValue,
      });
    }
  };



  const handleDeliveryDateChange = (event) => {
    // Convert the date to the desired format (MM/DD/YYYY)
    const dateValue = event.target.value;
    console.log(event, dateValue)
    // Update the orderDetail state with the formatted date
    setOrderDetail({
      ...orderDetail,
      deliverAt: dateValue,
    });
  };

  const handleDeleteRow = (index) => {
    const updatedRxList = [...orderDetail.orderdetail];
    updatedRxList.splice(index, 1);

    setOrderDetail({
      ...orderDetail,
      orderdetail: updatedRxList,
    });
  };

  const handleAddRow = () => {
    const newRxItem = {
      quantity: "1",
      rfnumber: "0",
      date: "",
      copay: "0.00",
      rxnumber: "M - ",
      select: false,
    }

    setOrderDetail({
      ...orderDetail,
      orderdetail: [...orderDetail.orderdetail, newRxItem],
    });
  };


  React.useEffect(() => {
    const pharmacyId = localStorage.getItem("pharmacyId");
    const userRole = localStorage.getItem("userType");
    if (userRole !== "PharmacyOwner" && userRole !== "PharmacyEmployee") {
      return;
    }
    if (pid !== undefined && parseInt(pid) !== parseInt(pharmacyId)) {
      navigation("/404");
      localStorage.removeItem("orderData");
    }
  }, [pid, navigation]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleSaveAndPrint = async (event) => {
    event.preventDefault();

    if (orderDetail?.orderdetail.length === 0) {
      toast.error("Order details are empty. Cannot process the order.", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return;
    }
    setLoading(true);
    const fileName = localStorage.getItem("myFile");

    const formData = new FormData();
    formData.append("deliverydate", orderDetail?.deliverydate);
    formData.append("order_file_name", orderDetail?.order_file);
    formData.append("language", orderDetail?.language || "english");
    formData.append("apart", orderDetail?.apart);

    formData.append(
      "deliveryTime",
      moment(orderDetail?.deliverAt).format("MM/DD/YYYY")
    );
    formData.append("name", orderDetail?.name);
    formData.append("address", orderDetail?.address);
    formData.append(
      "contact",
      orderDetail?.contact &&
        orderDetail?.contact !== "(___) ___-____"
        ? orderDetail?.contact
        : ""
    );
    formData.append(
      "cell",
      orderDetail?.cell &&
        orderDetail?.cell !== "(___) ___-____"
        ? orderDetail?.cell
        : ""
    );
    formData.append(
      "workNumber",
      orderDetail?.workNumber &&
        orderDetail?.workNumber !== "(___) ___-____"
        ? orderDetail?.workNumber
        : ""
    );
    formData.append("zip", orderDetail?.zip);
    formData.append("notes", orderDetail?.notes);
    formData.append("status", orderDetail?.status);
    formData.append("location_image", orderDetail?.streetViewUrl);
    formData.append("signature", orderDetail?.signature);
    formData.append("photoid", orderDetail?.photoid);
    formData.append("refrigrated", orderDetail?.refrigrated);
    formData.append("collectcopay", orderDetail?.collectcopay);
    formData.append("hippaform", orderDetail?.hippaform);
    formData.append("lineform", orderDetail?.lineform);
    formData.append("nfaqbform", orderDetail?.nfaqbform);
    formData.append("totalcopay", orderDetail?.totalcopay);
    formData.append("addresstype", orderDetail?.addresstype);
    if (orderDetail?.addresstype) {
      formData.append(
        "business_start_time",
        orderDetail?.business_start_time || ""
      );
      formData.append(
        "business_end_time",
        orderDetail?.business_end_time || ""
      );
    } else {
      formData.append("business_start_time", "");
      formData.append("business_end_time", "");
    }
    formData.append("parcelPlace", orderDetail?.parcelPlace);
    formData.append("lat", orderDetail?.lat);
    formData.append("lng", orderDetail?.lng);
    formData.append(
      "daily_order_id",
      parseInt(orderDetail?.daily_order_id)
    );
    formData.append("order_file", selectedOrderFile || null);
    formData.append("active", orderDetail?.active);

    formData.append("products", JSON.stringify(orderDetail?.orderdetail));
    try {
      const responsePersonal = await putApiWithAuth(
        CREATE_ORDER + `/${oid}`,
        formData
      );
      if (
        responsePersonal.data !== undefined &&
        responsePersonal.data.message !== "Duplicate order found"
      ) {
        toast.success("Order Updated Successfully!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setOrderResponse(responsePersonal.data);
        localStorage.removeItem("myFile");
        localStorage.removeItem("orderData");

      } else if (responsePersonal.data.error) {
        toast.error("Order File Format Does Not Match Our Criteria", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        localStorage.removeItem("myFile");
        localStorage.removeItem("orderData");
      }
    } catch (error) {
      toast.error("An error occurred. Please try again later.", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      localStorage.removeItem("myFile");
      localStorage.removeItem("orderData");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (orderResponse && Object.keys(orderResponse).length > 0) {
      if (componentRef && componentRef.current) {
        try {
          handlePrint();
        } catch (error) {
          console.error("Error occurred during handlePrint execution:", error);
        }
      } else {
        console.error(
          "componentRef is not set or invalid. Skipping handlePrint."
        );
      }
    }
  }, [orderResponse]);

  const handleSaveCancelNote = async (note) => {
    const formState = {
      cancel_note: note,
      cancelAt: "time",
    };
    const response = await patchApiWithAuth(
      CREATE_ORDER + `/${oid}`,
      formState
    );
    if (response.status !== 400) {
      toast.success("Order Cancelled Successfully!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      pid !== undefined ? navigation(`/order-list`) : navigation("/dashboard");
    } else {
      toast.error("Backend Error!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  console.log(orderDetail, "===========================>")

  return (
    <>
      <ToastContainer />
      <Box
        sx={{
          py: 1,
          display: "flex",
          flexDirection: "column",
          gap: 3,
          mx: "auto",
          maxWidth: "1700px",
          height: "calc(100vh - 60px)",
          overflow: "hidden",
        }}
      >
        <Box sx={{ display: "flex", gap: 4, flexGrow: 1, height: "100%" }}>
          <Box
            sx={{
              flexGrow: 2,
              display: "flex",
              flexDirection: "column",
              minWidth: "775px",
              height: "100%", // Restrict height to container
              overflowY: "auto", // Enable vertical scrolling
              paddingRight: "32px", // Add space on the right for the scrollbar
              "&::-webkit-scrollbar": {
                width: "4px", // Change width of the scrollbar
                backgroundColor: "#fff", // Background color of the scrollbar
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#cbd3da", // Color of the scrollbar thumb
                borderRadius: "5px", // Round edges of the scrollbar thumb
              },
              "&::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#555", // Darker color when hovered
              },
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box sx={{ flexGrow: 1 }}>
                <DateTimeFilters
                  handleOrderChange={handleOrderChange}
                  handleDeliveryDateChange={handleDeliveryDateChange}
                  orderDetail={orderDetail}
                  isEditable={isEditable}
                />
              </Box>
            </Box>
            <PatientDetails
              pharmacyDetail={pharmacyDetail}
              orderDetail={orderDetail}
              setOrderDetail={setOrderDetail}
              showData={showData}
              isEditable={isEditable}
              addressError={addressError}
              setAddressError={setAddressError}
            />
            <PatientOrderDetails
              handleOrderChange={handleOrderChange}
              handleDeleteRow={handleDeleteRow}
              handleAddRow={handleAddRow}
              orderDetail={orderDetail}
              isEditable={isEditable}
            />
            <DeliveryInstructions
              showData={showData}
              handleOrderChange={handleOrderChange}
              orderDetail={orderDetail}
              isEditable={isEditable}
            />
            <ActionButtons
              orderDetail={orderDetail}
              onSaveAndPrint={handleSaveAndPrint}
              isEditable={isEditable}
              onCancel={handleSaveCancelNote}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              width: "630px",
              maxHeight: "100%",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <TabButtons
              activeTab={activeTab}
              onTabChange={handleTabChange}
              orderDetail={orderDetail}
              handlePrintSlip={handlePrintSlip}
              pharmacyDetail={pharmacyDetail}
              downloadUploadSlip={downloadUploadSlip}
            />
            <SlipPreview activeTab={activeTab} orderDetail={orderDetail} pharmacyDetail={pharmacyDetail} />
          </Box>
        </Box>
      </Box>
      <div style={{ display: "none" }}>
        <div
          style={{
            margin: "13px",
            padding: "16px",
            maxWidth: "3.75in",
            color: "black",
          }}
          ref={componentRef}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              color: "black",
            }}
          >
            <div>
              <p
                style={{
                  margin: "0",
                  fontSize: "11px",
                  fontFamily: "Saira, sans-serif",
                  color: "black",
                }}
              >
                Date: {moment(orderResponse?.createdAt).format("MM/DD/YYYY")}
              </p>
              <p
                style={{
                  margin: "0",
                  fontSize: "11px",
                  fontFamily: "Saira, sans-serif",
                  color: "black",
                }}
              >
                Time: {moment(orderResponse?.createdAt).format("hh:mm:ss A")}
              </p>
            </div>
            <img
              src={pdfLogo}
              style={{ width: "120px", fontFamily: "Saira, sans-serif" }}
              alt="logo"
            />
            <div>
              <p
                style={{
                  margin: "0",
                  fontSize: "11px",
                  fontFamily: "Saira, sans-serif",
                  color: "black",
                }}
              >
                Order #: {orderResponse?.daily_order_id}
              </p>
            </div>
          </div>
          <hr />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              color: "black",
            }}
          >
            <div>
              <h3
                style={{
                  margin: "0",
                  fontSize: "15px",
                  fontWeight: 700,
                  padding: "5px 0",
                  fontFamily: "Saira, sans-serif",
                  color: "black",
                }}
              >
                Order ID:
                <span style={{ textDecoration: "underline" }}>
                  {orderResponse && orderResponse.slug}
                </span>
              </h3>
              <h3
                style={{
                  margin: "0",
                  fontSize: "15px",
                  fontWeight: 700,
                  padding: "5px 0",
                  fontFamily: "Saira, sans-serif",
                  color: "black",
                }}
              >
                CLIENT:
                <span style={{ textDecoration: "underline", color: "black" }}>
                  {orderResponse?.name}
                </span>
              </h3>
              <h5
                style={{
                  margin: "0",
                  fontSize: "15px",
                  fontWeight: 300,
                  padding: "5px 0",
                  fontFamily: "Saira, sans-serif",
                  color: "black",
                }}
              >
                Rx Count: {orderResponse?.orderdetail?.length}
              </h5>
              <h5
                style={{
                  margin: "0",
                  fontSize: "15px",
                  fontWeight: 700,
                  fontFamily: "Saira, sans-serif",
                  width: "150px",
                  color: "black",
                }}
              >
                Delivery Preference:
              </h5>
              <h5
                style={{
                  margin: "0",
                  fontSize: "14px",
                  fontWeight: 300,
                  padding: "0 5px",
                  textTransform: "uppercase",
                  fontFamily: "Saira, sans-serif",
                  width: "150px",
                  color: "black",
                }}
              >
                {orderResponse?.parcelPlace}
              </h5>
              <h4
                style={{
                  margin: "0",
                  fontSize: "15px",
                  fontWeight: 700,
                  padding: "5px 0",
                  fontFamily: "Saira, sans-serif",
                  color: "black",
                }}
              >
                Delivery Date:{" "}
                {moment(orderResponse?.deliverAtSelected).format("MM-DD-YYYY")}
              </h4>
              <h4
                style={{
                  margin: "0",
                  fontSize: "15px",
                  fontWeight: 700,
                  padding: "5px 0",
                  fontFamily: "Saira, sans-serif",
                  color: "black",
                }}
              >
                Time Window: {orderResponse?.deliverydate}
              </h4>
              {orderResponse?.notes !== "" && (
                <>
                  <p
                    style={{
                      margin: "0",
                      fontSize: "13px",
                      fontFamily: "Saira, sans-serif",
                      color: "black",
                    }}
                  >
                    <span
                      style={{
                        fontWeight: 600,
                        fontFamily: "Saira, sans-serif",
                        color: "black",
                      }}
                    >
                      Delivery Note:
                    </span>
                  </p>
                  <p
                    style={{
                      margin: "0",
                      fontSize: "13px",
                      padding: "5px 0",
                      fontFamily: "Saira, sans-serif",
                      width: "2.1in",
                      color: "black",
                    }}
                  >
                    {orderResponse?.notes}
                  </p>
                </>
              )}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "5px 0",
                color: "black",
              }}
            >
              {orderResponse?.totalcopay !== undefined &&
                orderResponse?.totalcopay !== 0 && (
                  <p
                    style={{
                      fontWeight: 700,
                      fontSize: "16px",
                      border: "2px solid black",
                      padding: "0 2px",
                      textAlign: "center",
                      marginBottom: "10px",
                      width: "90px",
                      color: "black",
                    }}
                  >
                    COPAY: $ {orderResponse?.totalcopay.toFixed(2)}
                  </p>
                )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  color: "black",
                }}
              >
                {orderResponse && Object.keys(orderResponse).length !== 0 ? (
                  <QRCodeSVG
                    value={orderResponse?.id?.toString()}
                    renderAs="svg"
                    size={80}
                  />
                ) : (
                  <QRCodeSVG renderAs="svg" size={80} value="no Order" />
                )}
                <h5
                  style={{
                    margin: "10px 0",
                    fontSize: "22px",
                    fontWeight: 800,
                    textTransform: "uppercase",
                    fontFamily: "Saira, sans-serif",
                    color: "black",
                  }}
                >
                  {orderResponse.city_code ? (
                    <>
                      {orderResponse.city_code}
                      {orderResponse.zone_code
                        ? ` - ${orderResponse.zone_code}`
                        : ""}
                    </>
                  ) : (
                    ""
                  )}
                </h5>
              </div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              fontFamily: "Saira, sans-serif",
              color: "black",
            }}
          >
            {(orderResponse?.hippaform ||
              orderResponse?.lineform ||
              orderResponse?.nfaqbform) && (
                <>
                  <h4
                    style={{
                      margin: "0",
                      fontSize: "14px",
                      fontWeight: 700,
                      padding: "10px 0",
                      fontFamily: "Saira, sans-serif",
                      color: "black",
                    }}
                  >
                    Get Forms Signed:
                  </h4>
                  <h5
                    style={{
                      margin: "0",
                      fontSize: "12px",
                      fontWeight: 700,
                      fontFamily: "Saira, sans-serif",
                      color: "black",
                    }}
                  >
                    {orderResponse?.hippaform && <span>Hipaa Form</span>}
                    {orderResponse?.lineform && (
                      <span
                        style={{
                          marginLeft: "8px",
                          fontFamily: "Saira, sans-serif",
                          color: "black",
                        }}
                      >
                        Lien Form
                      </span>
                    )}
                    {orderResponse?.nfaqbform && (
                      <span
                        style={{
                          marginLeft: "8px",
                          fontFamily: "Saira, sans-serif",
                          color: "black",
                        }}
                      >
                        NF AOB Form
                      </span>
                    )}
                  </h5>
                </>
              )}
            <div style={{ textAlign: "center", margin: 0 }}>
              {/* Header text */}
              <h4
                style={{
                  margin: 0,
                  fontSize: "16px",
                  fontWeight: "700",
                  fontFamily: "Saira, sans-serif",
                  color: "black",
                }}
              >
                {orderResponse?.refrigrated && orderResponse?.photoid
                  ? "Refrigerated / Photo ID"
                  : orderResponse?.photoid
                    ? "Photo ID"
                    : orderResponse?.refrigrated
                      ? "Refrigerated"
                      : ""}
              </h4>

              {/* Icon(s) */}
              <div
                style={{
                  marginTop: "5px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {orderResponse?.refrigrated && orderResponse?.photoid ? (
                  <>
                    <img
                      src={registered}
                      style={{ marginRight: "5px" }}
                      alt="Refrigerated Icon"
                    />
                    <img
                      src={photoId}
                      style={{ marginLeft: "5px" }}
                      alt="Photo ID Icon"
                    />
                  </>
                ) : orderResponse?.photoid ? (
                  <img src={photoId} alt="Photo ID Icon" />
                ) : orderResponse?.refrigrated ? (
                  <img src={registered} alt="Refrigerated Icon" />
                ) : null}
              </div>
            </div>
            <h5
              style={{
                margin: "0",
                marginTop: "10px",
                fontSize: "13px",
                fontWeight: 700,
                textAlign: "center",
                fontFamily: "Saira, sans-serif",
                color: "black",
              }}
            >
              From
            </h5>
            <h4
              style={{
                margin: "0",
                fontSize: "13px",
                fontWeight: 700,
                textAlign: "center",
                fontFamily: "Saira, sans-serif",
                color: "black",
              }}
            >
              {orderResponse?.pharmacy?.name}
            </h4>
            <h4
              style={{
                margin: "0",
                fontSize: "13px",
                fontWeight: 300,
                textAlign: "center",
                fontFamily: "Saira, sans-serif",
                color: "black",
              }}
            >
              {orderResponse?.pharmacy?.location}
            </h4>
            <h4
              style={{
                margin: "0",
                fontSize: "13px",
                fontWeight: 300,
                textAlign: "center",
                fontFamily: "Saira, sans-serif",
                color: "black",
              }}
            >
              Phone {orderResponse?.pharmacy?.contact_no}
            </h4>
          </div>
        </div>
      </div>

      {(orderDetail && pharmacyDetail) && (
        <div style={{ display: "none" }}>
          <div
            style={{
              display: "flex",
              textAlign: "center",
              justifyContent: "center",
              paddingTop: "10px",
            }}
            ref={componentRef2}
          >
            <Printdoc orderDetail={orderDetail} edit={true}
              upload={false}
              printt={true}
              view={false} pharmacy={pharmacyDetail} />
          </div>
        </div>
      )}
    </>
  );
};

export default EditPage;
